import * as moment from 'moment';
import { IReferenceData } from '../../interfaces/form/reference-data.model';

export class StudentProfileSubmitModel {
  student: any;
  address: any;
  submittedBy: string;

  constructor(data: any, referenceData: any) {
    this.student = {
      id: data?.nycId,
      firstName: data?.firstName,
      middleName: data?.middleName,
      lastName: data?.lastName,
      dob: data?.dateOfBirth
        ? moment(data?.dateOfBirth).format('YYYYMMDD')
        : '',
      sex: data?.gender ? data?.gender?.value : data?.gender,
      ethnicity: this.getEthnicityValues(data?.ethnicity),
      hispanicFlag: data?.hispanicFlag,
      phoneNumber: data?.phoneNumber,
      email: data?.email,
      homeLanguage: data?.homeLanguage?.value,
    };
    this.address = {
      streetNum: data?.streetNumber,
      street: data?.streetName,
      apartmentFloor: data?.apartmentNo,
      city: data?.city,
      boro: data?.borough ? data?.borough?.value : data?.borough,
      district: data?.district ? data?.district?.value : '',
      state: data?.state ? data?.state?.value : data?.state,
      zip: data?.zip,
    };
  }

  getEthnicityValues(ethnicity?: IReferenceData[]): string {
    if (ethnicity) {
      const ethnicityCode: string[] = [];
      ethnicity.forEach((code: IReferenceData) => {
        ethnicityCode.push(code.value);
      });
      return ethnicityCode.join(',');
    } else {
      return '';
    }
  }
}
